import Items from '../components/item'
import Loading from 'vue-loading-overlay'

export default {
  Items,
  Loading
}



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/index/resources/components.js